import { idmsApi } from "./api";
import {
  API_DEALER_CUSTOMER_SEARCH_ENDPOINT,
  API_DEALER_CUSTOMER_ENDPOINT,
} from "../../constants/endpoints";
import {
  DealerCustomerSearchRequest,
  DealerCustomerSearchResponse,
  DealerCustomerSaveRequest,
  DealerCustomerSaveResult,
} from "../interfaces/dealerCustomer";

const dealerCustomerApi = idmsApi.injectEndpoints({
  endpoints: (builder) => ({
    // Search for dealer customers
    searchDealerCustomers: builder.mutation<
      DealerCustomerSearchResponse,
      DealerCustomerSearchRequest
    >({
      query: (request) => ({
        url: API_DEALER_CUSTOMER_SEARCH_ENDPOINT,
        method: "POST",
        body: request,
      }),
    }),

    // Register/save dealer customers (supports multiple)
    saveDealerCustomers: builder.mutation<
      DealerCustomerSaveResult[],
      DealerCustomerSaveRequest[]
    >({
      query: (requests) => ({
        url: API_DEALER_CUSTOMER_ENDPOINT,
        method: "POST",
        body: requests,
      }),
    }),
  }),
});

export const {
  useSearchDealerCustomersMutation,
  useSaveDealerCustomersMutation,
} = dealerCustomerApi;
